export default __webpack_public_path__ + "static/media/empty_cart.ebb2c708.svg";